import { Button } from 'antd';
import { ArrowRightOutlined, CheckCircleFilled, LockOutlined } from '@ant-design/icons';
import '../styles/theme.css';

export default function AuthStatusShell({
  title,
  description,
  status,
  actionLabel,
  onAction,
  actionLoading = false,
  footnote,
}) {
  return (
    <main className="admin-auth-shell">
      <section className="admin-auth-panel" aria-labelledby="auth-status-title">
        <div className="admin-auth-panel-mark" aria-hidden="true">
          <LockOutlined />
        </div>
        <div className="admin-auth-panel-copy">
          <p className="admin-auth-eyebrow">Journiy admin</p>
          <h1 id="auth-status-title">{title}</h1>
          <p className="admin-auth-description">{description}</p>
        </div>
        {status && (
          <div className="admin-auth-status">
            <CheckCircleFilled />
            <span>{status}</span>
          </div>
        )}
        {actionLabel && (
          <Button
            className="admin-auth-action"
            type="primary"
            size="large"
            icon={actionLoading ? undefined : <ArrowRightOutlined />}
            loading={actionLoading}
            onClick={onAction}
          >
            {actionLabel}
          </Button>
        )}
        {footnote && <p className="admin-auth-footnote">{footnote}</p>}
      </section>
    </main>
  );
}